import { useState } from "react";

function OlvidePassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const enviar = async () => {
  if (!email.trim()) {
    alert("Ingrese un correo electrónico");
    return;
  }

  try {
    setLoading(true);

    const res = await fetch(
      "https://sindicato.sintrasecsalud.com/api/index.php?modulo=auth&accion=solicitarRecuperacion",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      }
    );

    const texto = await res.text();

    console.log("RESPUESTA RAW:", texto);

    try {
      const data = JSON.parse(texto);

      if (data.success) {
        alert("Revisa tu correo para cambiar la contraseña");
      } else {
        alert(data.message || "No fue posible enviar el correo");
      }
    } catch (e) {
      console.error("NO ES JSON:", texto);
      alert("El servidor devolvió HTML o texto en lugar de JSON");
    }

  } catch (error) {
    console.error("Error recuperación:", error);
    alert("Error al enviar el correo. Verifique el servidor.");
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="container text-center mt-5">
      <h4>Recuperar contraseña</h4>

      <input
        type="email"
        className="form-control my-3"
        placeholder="Tu correo"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />

      <button
        onClick={enviar}
        className="btn btn-warning"
        disabled={loading}
      >
        {loading ? "Enviando..." : "Enviar enlace"}
      </button>
    </div>
  );
}

export default OlvidePassword;